module.exports = __webpack_public_path__ + "img/e_1_5_g.6b560df8.png";